module.exports = __webpack_public_path__ + "img/symbol_11.39982713.png";